import baseIsEqualDeep from "./component-library443.mjs";
import isObjectLike from "./component-library270.mjs";
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
export {
  baseIsEqual as default
};
